var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    _vm._g(
      _vm._b(
        {
          attrs: {
            width: _vm.width,
            title: _vm.title,
            placement: _vm.placement,
            trigger: _vm.trigger,
          },
        },
        "el-popover",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : [
            _c("img", {
              staticClass: "qm-example__img",
              attrs: { src: _vm.url, alt: "示例图片", draggable: "false" },
            }),
          ],
      _vm.$slots.reference
        ? [_vm._t("reference", null, { slot: "reference" })]
        : [
            _c(
              "a",
              {
                staticClass: "qm-example__reference",
                attrs: { slot: "reference" },
                slot: "reference",
              },
              [_vm._v("查看示例")]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }